import { useLoadingSpinnerStore } from "~/stores/ui/loadingspinnerstore";

export default defineNuxtPlugin((nuxtApp) => {
  const globalLoadingStore = useLoadingSpinnerStore();

  nuxtApp.hook("page:loading:start", () => {
    console.debug("page:loading:start global Loading hook");
    globalLoadingStore.start();
  });

  // TODO These are too many loading end hooks, which is why sometimes we cannot see the loading
  // spinner when loading data inside the onMounted hook
  // but we need to make sure that the loading spinner is stopped when the page is finished loading,
  // otherwise there are navigation cases where is loading is infinite
  // we should refactor the loading spinner into a more advanced model.

  nuxtApp.hook("page:loading:end", () => {
    console.debug("page:loading:end global Loading hook");
    globalLoadingStore.stop();
  });
  nuxtApp.hook("page:finish", () => {
    console.debug("page:finish global Loading hook");
    globalLoadingStore.stop();
  });
  nuxtApp.hook("page:transition:finish", () => {
    console.debug("page:transition:finish global Loading hook");
    globalLoadingStore.stop();
  });

  nuxtApp.hook("app:error", () => {
    console.debug("app:error global Loading hook");
    globalLoadingStore.stop();
  });
});
